import { useProfileNotFilledNotification, useWhoami } from '~/modules/user/models/user.hooks';

export const UserModule = () => {
  useWhoami();
  useProfileNotFilledNotification();
  return <></>;
};
